<template>
    <b-img-lazy v-if="!heic" :src="src" :alt="alt" />
    <img v-else-if="converted" :src="converted" :alt="alt" />
    <div v-else class="d-inline-flex align-items-center justify-content-center bg-light">
        <small v-if="failed" class="text-muted text-center">Gagal memuat foto</small>
        <b-spinner v-else small variant="secondary" />
    </div>
</template>

<script>
import { isHeic, toJpegUrl } from "@/shared/heic";

export default {
    props: {
        src: { type: String, required: true },
        alt: { type: String, default: "" }
    },
    data() {
        return { converted: null, failed: false };
    },
    computed: {
        heic() {
            return isHeic(this.src);
        }
    },
    watch: {
        src: {
            immediate: true,
            handler(src) {
                this.converted = null;
                this.failed = false;
                if (!this.heic) return;
                toJpegUrl(src)
                    .then(url => {
                        if (this.src === src) this.converted = url;
                    })
                    .catch(() => {
                        if (this.src === src) this.failed = true;
                    });
            }
        }
    }
};
</script>
